import { PLATFORMS } from '../enums/platforms';

export function detectCurrentPlatform() {
    if (!navigator.userAgent) {
        return null;
    }

    if (navigator.userAgent.includes('Win')) {
        return PLATFORMS.WINDOWS;
    }
    if (navigator.userAgent.includes('Mac')) {
        return PLATFORMS.MACOS;
    }
    if (navigator.userAgent.includes('Linux')) {
        return PLATFORMS.LINUX;
    }

    return null;
}
